module.exports = __webpack_public_path__ + "img/19.56f64283.jpg";